import {configureStore} from "@reduxjs/toolkit";
import {landingSlice, productPageSlice} from "./reducers";
import {dashboardSlice} from "./reducers/dashboard-reducer";

export const store = configureStore({
    reducer: {
        landing: landingSlice.reducer,
        dashboard: dashboardSlice.reducer,
        productPage: productPageSlice.reducer,
    }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
